import { defineComponent as _defineComponent } from 'vue'
import { useStore, computed } from '@nuxtjs/composition-api';
import { convertToTitleCase } from '~/utils/formatStrings';

interface Props {
  sideNavClosed: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfileV2',
  props: {
    sideNavClosed: { type: Boolean }
  },
  setup(__props: any) {

const store = useStore();
const { loggedInUser } = store.getters;



const getPlanName = computed(() => {
  return loggedInUser.subscription && loggedInUser.subscription.code !== 'free'
    ? loggedInUser.subscription.name
    : loggedInUser.role.replace(/_/g, ' ');
});

return { __sfc: true,store, loggedInUser, getPlanName, convertToTitleCase }
}

})